import type { NextIntlKeys } from '@/i18n/types'
import type { StripeCardElementChangeEvent, StripeIbanElementChangeEvent } from '@stripe/stripe-js'
export type DonateNextIntlKeys = NextIntlKeys<'nextjs.donate'>

export type StripeChangeEvent = StripeCardElementChangeEvent | StripeIbanElementChangeEvent

export const StripeEventHandlerScope = {
  SEPA: 'sepa_debit',
  CC: 'cc',
} as const

export type StripeEventHandlerScope = (typeof StripeEventHandlerScope)[keyof typeof StripeEventHandlerScope]
